(() => {
  const markets = {
    gb: {
      domain: "www.rfrmactive.com",
      shortLabel: "GB",
      regionLabel: "United Kingdom (GBP £)",
    },
    us: {
      domain: "us.rfrmactive.com",
      shortLabel: "US",
      regionLabel: "United States (USD $)",
    },
    aus: {
      domain: "au.rfrmactive.com",
      shortLabel: "AU",
      regionLabel: "Australia (AUD $)",
    },
    eu: {
      domain: "eu.rfrmactive.com",
      shortLabel: "EU",
      regionLabel: "Europe (EUR €)",
    },
    int: {
      domain: "int.rfrmactive.com",
      shortLabel: "ROW",
      regionLabel: "Rest of World (USD $)",
    },
  };

  const marketAliases = {
    default: "gb",
    www: "gb",
    uk: "gb",
    gb: "gb",
    us: "us",
    au: "aus",
    aus: "aus",
    eu: "eu",
    int: "int",
  };

  const normalizeMarketKey = (value) => marketAliases[String(value || "").toLowerCase()] || "";

  const getMarketKeyFromHostname = (hostname = window.location.hostname) => {
    const normalizedHostname = String(hostname).toLowerCase().split(":")[0];
    const match = Object.entries(markets).find(([, market]) => market.domain === normalizedHostname);

    if (match) return match[0];
    if (normalizedHostname === "rfrmactive.com") return "gb";

    return "";
  };

  const buildMarketUrl = (marketKey) => {
    const normalizedKey = normalizeMarketKey(marketKey);
    const market = markets[normalizedKey];

    if (!market) return "";

    return `https://${market.domain}${window.location.pathname}${window.location.search}${window.location.hash}`;
  };

  const submitLocalization = (marketKey) => {
    const normalizedKey = normalizeMarketKey(marketKey);
    const localizationRoot = document.querySelector("[data-rfrm-market-localization]");
    const form = localizationRoot?.querySelector("form");
    const countryInput = form?.querySelector("[data-rfrm-market-country-input]");
    const countryCode = localizationRoot?.getAttribute(`data-country-${normalizedKey}`)?.trim();

    if (!form || !countryInput || !countryCode) return false;

    countryInput.value = countryCode;

    const returnToInput = form.querySelector('input[name="return_to"]');
    if (returnToInput) {
      returnToInput.value = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    }

    form.submit();
    return true;
  };

  const syncMarketToHostname = () => {
    const hostnameMarketKey = getMarketKeyFromHostname();
    const localizationMarketKey = normalizeMarketKey(
      document.querySelector("[data-rfrm-market-localization]")?.getAttribute("data-current-market")
    );

    if (!hostnameMarketKey || !localizationMarketKey) return false;

    const storageKey = "rfrm-market-host-sync";

    if (hostnameMarketKey === localizationMarketKey) {
      try {
        window.sessionStorage.removeItem(storageKey);
      } catch (_) {}

      return false;
    }

    try {
      const previousAttempt = JSON.parse(window.sessionStorage.getItem(storageKey) || "null");
      const attemptedRecently =
        previousAttempt?.marketKey === hostnameMarketKey &&
        Date.now() - Number(previousAttempt.timestamp || 0) < 30000;

      if (attemptedRecently) return false;

      window.sessionStorage.setItem(
        storageKey,
        JSON.stringify({ marketKey: hostnameMarketKey, timestamp: Date.now() })
      );
    } catch (_) {}

    return submitLocalization(hostnameMarketKey);
  };

  const navigate = (marketKey) => {
    if (submitLocalization(marketKey)) return;

    const nextUrl = buildMarketUrl(marketKey);
    if (!nextUrl) return;

    window.location.assign(nextUrl);
  };

  const syncCurrentMarket = (root = document) => {
    const localizationMarketKey = normalizeMarketKey(
      document.querySelector("[data-rfrm-market-localization]")?.getAttribute("data-current-market")
    );
    const marketKey = localizationMarketKey || getMarketKeyFromHostname();
    const market = markets[marketKey];

    if (!market) return;

    document.documentElement.dataset.currentMarket = marketKey;

    root.querySelectorAll("[data-current-market-short]").forEach((label) => {
      label.textContent = market.shortLabel;
    });

    root.querySelectorAll("[data-current-market-label]").forEach((label) => {
      label.textContent = market.regionLabel;
    });

    root.querySelectorAll("[data-market-key]").forEach((option) => {
      const optionKey = normalizeMarketKey(option.dataset.marketKey);
      const isCurrent = optionKey === marketKey;

      option.classList.toggle("active", isCurrent);
      option.classList.toggle("active-market", isCurrent);

      if (isCurrent) {
        option.setAttribute("aria-current", "page");
      } else {
        option.removeAttribute("aria-current");
      }
    });

    root.querySelectorAll("[data-current-market-indicator]").forEach((indicator) => {
      const option = indicator.closest("[data-market-key]");
      indicator.hidden = normalizeMarketKey(option?.dataset.marketKey) !== marketKey;
    });

    const selectedFlag = root.querySelector(`[data-market-key="${marketKey}"] img`);
    if (selectedFlag) {
      root.querySelectorAll("img[data-current-market-flag]").forEach((flag) => {
        flag.src = selectedFlag.src;
        flag.alt = selectedFlag.alt;
      });
    }
  };

  const closeLocalizationLists = (exceptWrapper) => {
    document.querySelectorAll(".localization-wrapper").forEach((wrapper) => {
      if (wrapper === exceptWrapper) return;
      wrapper.querySelector(".localization-list")?.classList.remove("active");
      wrapper.querySelector(".localization-button")?.classList.remove("active");
    });
  };

  document.addEventListener("click", (event) => {
    const localizationButton = event.target.closest(".localization-button");

    if (localizationButton) {
      const wrapper = localizationButton.closest(".localization-wrapper");
      const list = wrapper?.querySelector(".localization-list");

      if (list) {
        event.preventDefault();
        event.stopPropagation();
        closeLocalizationLists(wrapper);
        list.classList.toggle("active");
        localizationButton.classList.toggle("active", list.classList.contains("active"));
      }

      return;
    }

    const marketOption = event.target.closest("[data-market-key][data-market-domain]");

    if (marketOption) {
      const isModifiedAnchorClick =
        marketOption.matches("a") &&
        (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0);

      if (!isModifiedAnchorClick) {
        event.preventDefault();
        navigate(marketOption.dataset.marketKey);
      }

      return;
    }

    if (!event.target.closest(".localization-wrapper")) closeLocalizationLists();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Enter" && event.key !== " ") return;

    const marketOption = event.target.closest("[data-market-key][data-market-domain]:not(a)");
    if (!marketOption) return;

    event.preventDefault();
    navigate(marketOption.dataset.marketKey);
  });

  window.RfrmMarketSelector = {
    buildMarketUrl,
    getMarketKeyFromHostname,
    navigate,
    submitLocalization,
    syncMarketToHostname,
    syncCurrentMarket,
  };

  const initializeMarketSelector = () => {
    if (syncMarketToHostname()) return;
    syncCurrentMarket();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeMarketSelector);
  } else {
    initializeMarketSelector();
  }

  document.addEventListener("shopify:section:load", (event) => syncCurrentMarket(event.target));
})();
